import React from 'react';

interface MetricCardProps {
  label: string;
  value: string;
  sub?: string;
  accent?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({ label, value, sub, accent }) => (
  <div
    className='rounded-lg border px-4 py-3.5 flex flex-col gap-1'
    style={{ background: 'var(--pp-surface)', borderColor: 'var(--pp-border)' }}
  >
    <span
      className='text-[11px] font-medium uppercase'
      style={{ color: 'var(--pp-text-subtle)', letterSpacing: '0.06em' }}
    >
      {label}
    </span>
    <span
      className='text-2xl font-semibold tabular-nums'
      style={{ color: accent ?? 'var(--pp-text)', letterSpacing: '-0.02em' }}
    >
      {value}
    </span>
    {sub && (
      <span className='text-xs' style={{ color: 'var(--pp-text-subtle)' }}>{sub}</span>
    )}
  </div>
);

export default MetricCard;
